import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img as ImgUI} from 'ui';
import {ToastContainer} from 'react-toastify';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const TextArea = styled('div')({
  maxWidth: 200,
  marginRight: 13,
  marginLeft: 13,
  color: colors.darkBrown,
});

export const Img = styled(ImgUI)({
  borderRadius: 10,
  width: 60,
  height: 60,
  objectFit: 'cover',
});

export const NotificationContainer = styled(ToastContainer)({
  margin: 21,
  marginTop: 91,
  width: 'auto',
  //background: colors.beige,
  borderRadius: 10,
});
